import { useEffect } from "react";

const SITE = "https://expansionrubi.com";

export default function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return;
    const sid = `jsonld-${id}`;
    let el = document.getElementById(sid);
    if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = sid; document.head.appendChild(el); }
    el.textContent = JSON.stringify(data);
    return () => { el?.remove(); };
  }, [id, data]);
  return null;
}

export function organizationSchema(brand) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Rubí Perfumería",
    alternateName: "Expansión Rubí",
    url: SITE,
    logo: `${SITE}/expansion-rubi-logo.png`,
    description: "Empresa mexicana pionera en perfumería de alta gama a precio accesible, con 39 sucursales en 17 estados y proyectos de participación privada para nuevas aperturas.",
    foundingDate: "2005",
    areaServed: { "@type": "Country", name: "México" },
    contactPoint: [{ "@type": "ContactPoint", contactType: "sales", telephone: brand?.whatsapp ? `+${brand.whatsapp}` : undefined, availableLanguage: ["es"] }],
    sameAs: brand?.instagram ? [brand.instagram] : undefined,
  };
}

export function faqSchema(items = []) {
  if (!items.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.filter((i) => i.q && i.a).map((i) => ({ "@type": "Question", name: i.q, acceptedAnswer: { "@type": "Answer", text: i.a } })),
  };
}

export function websiteSchema() {
  return { "@context": "https://schema.org", "@type": "WebSite", name: "Expansión Rubí", url: SITE, inLanguage: "es-MX", publisher: { "@type": "Organization", name: "Rubí Perfumería" } };
}

export function breadcrumbSchema(items) {
  return { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: `${SITE}${it.path}` })) };
}
